import React, { useCallback, useContext } from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react-lite';
import { DragDropContext } from 'react-beautiful-dnd';
import sortBy from 'lodash/sortBy';
import Group from './Group';
import ItemSuffix from './ItemSuffix';
import TabsContext from '../../TabsContext';
const TabGroups = function TabGroups(props) {
    const { dataSet, defaultKey, onDefaultKeyChange } = props;
    const { groupedTreeRecords } = dataSet;
    const { prefixCls, groupedPanelsMap } = useContext(TabsContext);
    const handleDragItem = useCallback(action((srcIndex, destIndex, groupKey) => {
        const group = groupedTreeRecords.find(({ value = 'default' }) => value === groupKey);
        if (group) {
            const records = sortBy(group.records, [r => r.get('sort')]);
            const [removed] = records.splice(srcIndex, 1);
            records.splice(destIndex, 0, removed);
            records.forEach((r, index) => r.set('sort', index));
        }
    }), [dataSet, groupedTreeRecords]);
    const handleDragEnd = useCallback(({ destination, source: { droppableId: srcDroppableId, index: srcIndex } }) => {
        if (destination) {
            const { index: destIndex } = destination;
            if (srcIndex !== destIndex) {
                handleDragItem(srcIndex, destIndex, srcDroppableId);
            }
        }
    }, [handleDragItem]);
    const treeNodeSuffix = useCallback((record, index, records) => (React.createElement(ItemSuffix, { record: record, index: index, records: records, groups: groupedTreeRecords, defaultKey: defaultKey, onDefaultKeyChange: onDefaultKeyChange })), [groupedTreeRecords, defaultKey]);
    function getGroupHeader(groupKey) {
        const groupPaneMap = groupedPanelsMap.get(groupKey);
        if (groupPaneMap) {
            return groupPaneMap.group.tab;
        }
    }
    const groups = groupedTreeRecords.map(({ value = 'default', records }) => (React.createElement(DragDropContext, { key: String(value), onDragEnd: handleDragEnd },
        React.createElement(Group, { value: value, header: getGroupHeader(value), records: records, nodeSuffix: treeNodeSuffix, defaultKey: defaultKey }))));
    return (React.createElement("div", { className: `${prefixCls}-customization-panel-content` }, groups));
};
TabGroups.displayName = 'TabGroups';
export default observer(TabGroups);
